import styled from '@emotion/styled';
import {
  breakpoints,
  colors,
  fonts,
  pxToCssFont,
  theme,
  media,
  sunrisePrimitives,
} from '@vfit/shared/themes';

export const Container = styled.div`
  margin: 0 auto ${theme.spacing.xl};
  font-style: normal;
  color: ${colors.$262626};
  width: 287px;

  @media (min-width: ${breakpoints.tablet}) {
    width: 366px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 406px;
  }
`;

export const Title = styled.div`
  font-family: ${fonts.exbold};
  font-weight: 400;
  text-align: center;
  ${pxToCssFont(30, 38)}
  margin-bottom: 16px;
  margin-top: 36px;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(42, 52)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
  }
`;

export const Description = styled.div`
  font-family: ${fonts.regular};
  font-weight: 400;
  text-align: center;
  ${pxToCssFont(20, 26)}
  margin-bottom: 32px;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
    margin-bottom: 26px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-bottom: 40px;
  }
`;

export const Subtitle = styled.div`
  text-align: start;
  font-family: ${fonts.exbold};
  font-weight: 400;
  ${pxToCssFont(20, 26)}
  margin-bottom: 16px;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(24, 30)}
    margin-bottom: 20px;
  }
`;

export const CheckboxDescription = styled.div`
  text-align: start;
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};

  ${media.tablet`
      font-size: ${theme.typography.fontSize.body1};
      line-height: ${theme.typography.lineHeight.body1};        
  `}
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: ${theme.spacing.xl};
`;

export const Checkbox = styled.label`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 34px;

  .custom-checkbox {
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .custom-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 2;
    left: 2;
    margin-top: ${theme.spacing.xs};
    height: 20px;
    width: 20px;
    border-radius: 3px;
    border: 1px solid ${theme.colors.border.default};
  }

  .checkmark::after {
    content: '';
    position: absolute;
    display: none;
  }

  .custom-checkbox .checkmark:after {
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .custom-checkbox:hover input ~ .checkmark {
    border: 1px solid ${theme.colors.border.default};
  }

  .custom-checkbox input:checked ~ .checkmark {
    background-color: ${sunrisePrimitives.cyanDark};
    border: none;
  }

  .custom-checkbox input:checked ~ .checkmark::after {
    display: block;
  }
`;

